export enum ContactPrefix {
  Malaysia = '+60',
  Philippines = '+63',
}
